module.exports = __webpack_public_path__ + "static/media/bathroom-sink-clean.3dbb006b.png";